'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _format = require('@marmalade/format');

// Takes a number and returns a string converting number to hours and minutes - 78 = 1 hour 18 minutes
var numToHrsMins = function numToHrsMins(num) {
  if (num < 60) {
    var _mins = Math.round(num);
    return _mins + ' min' + (0, _format.pluralise)(_mins);
  }
  var hours = Math.floor(num / 60);
  var mins = Math.round(num % 60);
  return hours + ' hour' + (0, _format.pluralise)(hours) + ' ' + mins + ' min' + (0, _format.pluralise)(mins);
};
exports.default = numToHrsMins;